<main>
    <div class="app app-margin">
        <section class="nav-area" [dir]="textDir">             
            <div class="row top-section padT15">
                <div class="md-12 lg-12 xl-12">
                    <section class="breadcrmb labeltxt">
                        <a [routerLink]="['/']" >{{'Home' | translate}}</a> 
						<span class="eds-sep">&nbsp;/&nbsp;</span> 
						<a [routerLink]="['/myclassroom']">{{'My classes' | translate}}</a>
						<span class="eds-sep">&nbsp;/&nbsp;</span> 
                        <span class="active">{{_sessionData?.grade?.name}}&nbsp;{{_sessionData?.name}} {{'Class' | translate}}</span>
                    </section>
                    <div class="row">
                        <div class="lg-10">
                            <div class="marT10 header-title">{{_sessionData?.name}} {{'Class' | translate}}</div>
						</div>
						
					</div>
					<div class="row">
                        
						<div class="lg-12 flexEnd padT10" *ngIf="this.isGroupExists && this.groupListData">
							<button (click)="createNewGroupModel()" class="btn primary hgt-24">{{'Add new group' | translate}}</button>
						</div>
                    </div>
				</div>
				<!-- <div class="md-12 lg-12 xl-12">
					<ul class="pro-overview-head-icons ">
						<li class="marR12">
							{{_sessionData?.grade}}
						</li>
						<li class="marR12" *ngIf="_sessionData?.count > 1">
							{{_sessionData?.count}} Students
						</li>
						<li *ngIf="_sessionData?.count <= 1">
							{{_sessionData?.count}} Student
						</li>
						<li>
							{{groupListCount > 0 ? groupListCount : 0}} Group{{groupListCount > 0 ? 's' : ''}}
						</li>
					</ul>
				</div> -->

				<!-- <div class="row" style="opacity:0.8; font-size:12px;">
					<div class="md-12 lg-12 xl-12">
						<span style="margin-right: 11px;" >&nbsp;{{_sessionData?.grade}}</span>|
						<span style="margin-right: 11px;" *ngIf="_sessionData?.count > 1">&nbsp;{{_sessionData?.count}} Students</span>						
						<span style="margin-right: 11px;" *ngIf="_sessionData?.count <= 1">&nbsp;{{_sessionData?.count}} Student</span>|
						<span style="margin-left:9px">&nbsp;{{groupListCount > 0 ? groupListCount : 0}} Group{{groupListCount > 0 ? 's' : ''}} </span>
					</div>
				</div>    -->
            </div>
		</section>
		<div class="app-container top-section hgt-103 project-overview-container minmarT22" [dir]="textDir">
			<div class="row">
				<div class="tabs sm-12" >
					<div class="titles">
						<div class="title selected" (click)="getStudentListData()">{{'Students' | translate}} ({{_sessionData?.count}})</div>
						<div class="title" (click)="getGroupListData()">{{'Groups' | translate}} ({{groupListCount}})</div>
					</div>
					<div class="contents">
						<!-- Student tab -->
						<div class="content selected">
							<div class="loading" *ngIf="showLoader"></div>
							<div class="row marT10" *ngIf="!showLoader" >								
								<div class="lg-6 md-6 sm-12 proj-filters flexEnd"></div>
								<div class="lg-6 md-6 sm-12 flexEnd proj-search">
									<div class="dwnAdmin  marR30"> <a href="javascript:void(0)" (click)="downloadCsv(this.studentListData,'Students')" class="dwnText">{{'Download dataset' | translate}}</a></div>
									<!-- <div class="marR20 ">
										<input type="text" class="with-icon font12 search" [(ngModel)]="filterQuery" placeholder="{{'Search by name' | translate}}" name="q">
										<div class="suffix icon-inside"><i class="icon icon-search font16 eds-txt-blck"></i></div>
									</div> -->
									<div [ngClass]="textDir=='rtl'?'marL20':''">
										<input type="text" class="with-icon inputwdith font12 search" [(ngModel)]="filterQuery" placeholder="{{'Search by name'| translate}}" name="q">
										<div class="suffix icon-inside" [ngClass]="textDir=='rtl'?'marR38':''"><i class="icon icon-search"></i></div>
										
									</div>
									<div class="flexEnd">
										<div class="grid-icon">
											<label class="padT5" [ngClass]="{'selected':gridSelectedStudent}">
												<input type="Radio" name="radio2text" value="gridView" (click)= 'setGrid("student")' checked="checked"><i class="icon icon-view-tiles"></i>
												<span class="checkmark"></span>
											</label>
										</div>
										<div class="list-icon">
											<label class="padT5" [ngClass]="{'selected': !gridSelectedStudent}">
												<input type="Radio" name="radio2text" value="listView" (click)= 'setList("student")' unchecked=""><i class="icon icon-view-list"></i>
												<span class="checkmark"></span>
											</label>
										</div>
									</div>
								</div>
							</div>
							<div class="row lg-12 md-12 sm-12" *ngIf="!showLoader">
								<div *ngIf="!studentListData && isStudentExists">
									<div class="alert alert-danger text-center">
										<strong>{{'No match found in the system' | translate}}</strong>
									</div>
								</div>
								<div *ngIf="studentListData && gridViewS" class="md-12 marB20">
									<div class="marT20 grid-align">
										<div *ngFor="let student of studentListData|filterBy: ['name']: filterQuery |paginate: { id: 'sgrid', itemsPerPage: noOfItems, currentPage: page }">
											<div class="student-card flexStart item-middle curPointer" (click)="displayStudentDetails(student?._id)">
												<div class="pad13" [ngClass]="{'grayed': !student.active}" >
													<img *ngIf="student?.logo?.url"
													src="{{student?.logo?.url?.replace('<FILEBASEURL>', environment.msdpAPIBaseURL)}}"
													class="img-circle img-responsive imgStudentsComponent" width="60" height="60">
													
													<div class="img-circle-60" *ngIf="!student?.logo?.url"><label class="cir-txt">{{student?.first_name.substring(0,1).toUpperCase()}}{{student?.last_name.substring(0,1).toUpperCase()}}</label></div>
												</div>												
												<div class="padT20 padB20 w63 curPointer" [ngClass]="{'grayed': !student.active}" >
													<label class="labeltxt curPointer" style="text-transform: capitalize;">{{student.first_name}}</label>
													<label class="labeltxt curPointer" style="text-transform: capitalize;">{{student.last_name}}</label>
												</div>
												<div >
													<img *ngIf="student.active==false" class="archive_icon" src="assets/images/icon_archive.png" >												
												</div>
											</div>
										</div>
									</div>
								</div>
								<div *ngIf="studentListData && !gridViewS" class="md-12">
									<div class="scrollbar scrollbar-grey">
										<table class="table sortable selectable dashed">
											<thead>
											  	<tr>
													<th style="width:250px;" (click)="sortBy('first_name')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'first_name','desc':this.isSorted && this.propertyName == 'first_name' && this.orderType,'asc':this.isSorted && this.propertyName == 'first_name' && !this.orderType}">{{'Student name' | translate}}</th>
													<th (click)="sortBy('gender')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'gender','desc':this.isSorted && this.propertyName == 'gender' && this.orderType,'asc':this.isSorted && this.propertyName == 'gender' && !this.orderType}">{{'Gender' | translate}}</th>
													<th (click)="sortBy('date_of_birth')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'date_of_birth','desc':this.isSorted && this.propertyName == 'date_of_birth' && this.orderType,'asc':this.isSorted && this.propertyName == 'date_of_birth' && !this.orderType}">{{'Date of birth' | translate}}</th>
													<th style="width:200px;" (click)="sortBy('class.name')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'class.name','desc':this.isSorted && this.propertyName == 'class.name' && this.orderType,'asc':this.isSorted && this.propertyName == 'class.name' && !this.orderType}">{{'Class' | translate}}</th>
													<th (click)="sortBy('class.grade.name')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'class.grade.name','desc':this.isSorted && this.propertyName == 'class.grade.name' && this.orderType,'asc':this.isSorted && this.propertyName == 'class.grade.name' && !this.orderType}">{{'Grade' | translate}}</th>																										
													<th  (click)="sortBy('active')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'active','desc':this.isSorted && this.propertyName == 'active' && this.orderType,'asc':this.isSorted && this.propertyName == 'active' && !this.orderType}">{{'Status' | translate}}</th>
												</tr>
											</thead>
											<tbody>
												<tr style="cursor: pointer;" *ngFor="let item of studentListData | orderBy: propertyNameSorting | filterBy: ['first_name', 'last_name']: filterQuery | paginate: { id: 'slist', itemsPerPage: noOfItems, currentPage: page }; let i = index" (click)="displayStudentDetails(item?._id)"
													app-ctl-list-view dataView="list"
													(viewDataEvent)="displayStudentDetails(item?._id)"
													[showlogo]=false
													[title]="item?.first_name + ' ' + item?.last_name"
													[info4]="item?.class?.grade?.name+ ' ('+ item?.class?.grade?.year?.name+ ')'"
													[info3]="item?.class?.name"
													[extrainfo2]="item?.date_of_birth"
													[extrainfo1]="item?.gender"
													[status]="item?.active"
													[row]="item?.active"
													[loopIndex]=i>
												</tr>
											</tbody>
										</table>
										
										<div class="lg-12 md-12 sm-12 center">
											<pagination-controls
												id="slist"
												(pageChange)="page = $event"
												[autoHide]=true
												[responsive]="'responsive'"
												[previousLabel]="''"
												[nextLabel]="''"></pagination-controls>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- Groups tab -->
						<div class="content">
							<div class="row marT10">
								<div class="loading" *ngIf="showLoader"></div>
								<ng-container *ngIf="!groupListData && !showLoader">
									<div class="row flexCenter marT30">
									<div class="card setup-school-card wid-360 hgt-260">                          
										<div class="content text-center">
											<div class="school-setup-icon">
											<img src="assets/images/Group.png" width="82" alt="">
											</div>                            
											<div class="title module-title dashboard-item-title marT15">
												{{'Add a new group' | translate}}
											</div>
											<div class="module-desc dashboard-item-subtitle marT10 padLR15">{{'There are no groups in this class' | translate}}</div>
											<div class="school-setup-button marT30">
												<a data-toggle="modal" (click)="createNewGroupModel()" class="btn primary marT20">{{'Add new group' | translate}}</a>
											</div>											
										</div>
									</div> 
								</div> 
									<div class="row flexCenter marT20">
										<div class="wid-360 flexStart">
											<div class="info-txt"><i class="icon icon-info padL5 padT2"></i></div>
											<div><label class="info-txt text-center">{{'You can use groups to encourage students to work in a team or share content to suit the learning level of those students.' | translate}}</label></div>
										</div>
									</div>
								
								</ng-container>
								<ng-container *ngIf="groupListData && !showLoader">

									<div class="lg-12 md-12 sm-12 flexEnd proj-search">
										<div class="dwnAdmin marR30"> <a href="javascript:void(0)" (click)="downloadCsv(this.groupListData,'Groups')" class="dwnText">{{'Download dataset' | translate}}</a></div>
										<div [ngClass]="textDir=='ltr'?'marR20':'marL10'">
											<!-- <input type="text" class="with-icon font12 search" [(ngModel)]="filterQuery" placeholder="{{'Search by name' | translate}}" name="q">
											<div class="suffix icon-inside"><i class="icon icon-search font16 eds-txt-blck"></i></div> -->
											<input type="text" class="with-icon inputwdith font12 search" [(ngModel)]="filterQuery" placeholder="{{'Search by name'| translate}}" name="q">
                        				<div class="suffix icon-inside" [ngClass]="textDir=='rtl'?'marR38':''"><i class="icon icon-search"></i></div>
										</div>
										<div class="flexEnd padR10">
											<div class="grid-icon">
                                                <label class="padT5" [ngClass]="{'selected':gridSelectedGroup}">
                                                    <input type="Radio" name="radio2text" value="gridView" (click)= 'setGrid("group")' checked="checked"><i class="icon icon-view-tiles"></i>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="list-icon">
                                                <label class="padT5" [ngClass]="{'selected': !gridSelectedGroup}">
                                                    <input type="Radio" name="radio2text" value="listView" (click)= 'setList("group")' unchecked=""><i class="icon icon-view-list"></i>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
										</div>
									</div>
									<div *ngIf="groupListData && gridViewG" class="row scollbar scrollbar-grey grid-align marT20 marB20" >
										<div class="sm-12 xs-12 " *ngFor="let group of this.groupListData | filterBy: ['name']: filterQuery| paginate: { id: 'slist',itemsPerPage: noOfItems, currentPage: page }; let i = index">	
											<div class="group-card" *ngIf="groupListData" (click)="groupDetails(group)" style="cursor: pointer;">
												<div class="row padT25 padB25 padLR20 flexStart">
													<div class="md-2">													
														<!-- <div *ngFor="let grades of gradeList; let j = index;" [ngClass]="[ grades?.name==classRoom?.grade?.name ? 'circle-text'+(j+1) : '']" ></div> -->
														<div>
															<!-- <i class="icon icon-group font30 text-center"></i> -->
															<img src="assets/images/group_card_icon.png" style="width: 50px;" alt="">
														</div>
													</div>
													<div class="md-8" [ngClass]="textDir=='rtl'?'marR20':'marL20'">
														<div class="media-body">
															
															<label class="form-title" style="text-transform: capitalize;"> <a (click)="groupDetails(group)" class="eds-txt-blck cur-poi">{{group?.name}} {{'group' | translate}}</a></label>  
															
															<label class="label-light txt-hgt-42">{{group?.description}}</label>
															
															<div class="flexStart marT15">
																<div class="flexStart">																
																	<img src="assets/images/group_icon_small.png" style="height: 14px;margin: 2px;" [ngClass]="textDir=='rtl'?'marL5':'marR5'" alt="">
																	<label class="labeltxt"> {{group?.students?.length}} {{'Student' | translate}}<span *ngIf="group.students?.length>1">s</span></label>
																</div>
																<div class="flexStart" [ngClass]="textDir=='rtl'?'marR15':'marL15'">
																	<div class="opac-5"><i class="icon icon-home"></i></div>
																	<label class="labeltxt" [ngClass]="textDir=='rtl'?'marR5':'marL5'">{{_sessionData?.name}}</label>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>									
										</div>
									</div> 

									<div *ngIf="groupListData && !gridViewG" class="md-12">
										<div>
											<table id="groupTable" class="table selectable dashed">
												<thead>
													<tr>
														<th style="width:200px;">{{'Group name' | translate}}</th>
														<th style="width:15px;">{{'Students' | translate}}</th>
														<th style="width:150px;">{{'Class' | translate}}</th>
														<th style="width:570px;">{{'Group description' | translate}}</th>													
													</tr>
												</thead>
												<tbody>
													<tr style="cursor: pointer;" *ngFor="let item of groupListData |orderBy: propertyNameSorting | filterBy: ['name']: filterQuery | paginate: { itemsPerPage: noOfItems, currentPage: page }; let i = index" (click)="groupDetails(item)"

														app-ctl-list-view dataView="list"
														(viewDataEvent)="groupDetails(item)"
														[showlogo]=false
														[title]="item?.name"
														[info2]="item.students.length"
														[info3]="_sessionData?.name"
														[info4]="item?.description"	
														[row]="'true'"												
														[loopIndex]=i>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									<div class="lg-12 md-12 sm-12 center">
										<pagination-template id="slist" #p="paginationApi"  (pageChange)="page = $event">                                    
											<lib-ctl-pagination [p]="p"></lib-ctl-pagination>
										</pagination-template>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>

<!-- group add/edit -->
<lib-modalform
	modalClass="school"
	modalID="groupModal"
	[viewType]="curView"
	[modalTitle]="groupModalTitle"
	[modalInfo]="groupModalInfo"
	[btnDeleteText]="deleteText"
	[btnSaveText]="btnSave"
	[btnSendText]="btnSend"
	[btnSaveStatus]="btnSaveStatus"
	[btnCancelText]="btnCancel"
	[btnEditText]="btnTextEdit"
	(evEnableDelete)="deleteGroup()"
	(evEnableEdit)="updateGroupModel()"
	(saveEvent)="saveGroupData()"	
	(cancelEvent)="closeModal('groupModal')">
	<div class="modalBody">
		<app-ctl-sch-classgroup-form
			[viewType]="curView"
			[myClass]="_sessionData"
			[myForm]="groupForm"
			[groupData]="groupDetailsData"
			[selectedStudents]="groupStudents"
			[myStudentsList]="studentListData"
			(evFormUpdate)="formChange()"
			(evCheckUpdate)="checkStatus($event)"
			>
		</app-ctl-sch-classgroup-form>
	</div>
</lib-modalform>

<!-- add/edit teacher/student/admin modal -->
<lib-modalform
    modalClass="admin"
	modalID="userModal"
	[isTeacher]=true
    [viewType]="'read'"
    [modalTitle]=""
    [btnSaveText]="btnSave"
    [btnSendText]="btnSend"
    [btnSaveStatus]="''"
	[btnCancelText]="btnCancel"
    (saveEvent)="''"
    (cancelEvent)="closeModal('userModal')"
    (sendEvent)="''">
    <div class="modalBody">
		<app-ctl-new-user-form
		[isTeacher]=true
        [data]="studentDetails"
        [myrole]="'Student'"
        [viewType]="'read'">
    </app-ctl-new-user-form>
    </div>
</lib-modalform>
<!-- add/add admin modal -->

<lib-ctl-confirm-modal
  modalID="groupDeleteConifrmModal"
  [titleMessage]=this.titleMessage
  [subTitleMessage]=groupDetailsData?.name
  [detailMessage]="''"
  [listMessage]="''"
  [detailMessageLine1]="''"
  (confirm)="invokeDeleteGroupService(deleteGroupId)">
</lib-ctl-confirm-modal>

<lib-ctl-success-modal
  [titleMessage]=this.titleMessage
  [subTitleMessage]=this.subTitleMessage
  [detailMessage]=this.detailMessage
  ></lib-ctl-success-modal>

<!-- Error modal -->
<lib-modalform
	modalClass="errorModal"
	modalID="errorModal"
	[viewType]="'add'"
	[modalTitle]="titleMessage"
	[btnCancelText]="'Ok'">
	<div class="modalBody errorModalWidth">
		<div class="padLR20  padT20 flexStart">
			<div [ngClass]="textDir=='ltr'?'marR15':'marL15'">
				<img src="assets/images/error3x.png" width=29 height=29 alt="">
			</div>
			<div> 
				<label class="form-title"> {{this.titleMessage}}</label>
			</div>
		</div>
		<div class="pad65 padR20 padB20 dialog-body-txt">
			<label>{{this.detailMessage}}</label>
			<label *ngIf="this.detailMessage1">{{this.detailMessage1}}</label>
		</div>
	</div>
</lib-modalform>
<!-- END Error modal for check and import -->
